export const FAQ = [
  {
    translation: 'm_its_not_in_junk_or_spam',
    fallback: 'It’s not in your Junk or Spam folders'
  },
  {
    translation: 'm_its_not_on_blocked_list',
    fallback: 'None of our emails are on your blocked list'
  },
  {
    translation: 'm_your_inbox_isnt_full',
    fallback: "Your inbox isn't full or rejecting external emails"
  },
  {
    translation: 'm_add_hello_at_beans_to_your',
    fallback:
      "Add <a href='mailto:hello@studentbeans.com'>hello@studentbeans.com</a> to your safe senders list"
  }
]

export const BACK_TO_LOGIN = 'Back to login'
export const EMAIL_DIDNT_ARRIVE = "Email didn't arrive?"
export const DOUBLE_CHECK = 'Double check:'
export const RESEND_IN = 'Resend in'
export const RESEND_RESET_LINK = 'Resend Reset Link'
export const RESEND_INTERVAL = 10
export const EMAIL_RESENT = 'Email re-sent!'
export const ERROR = 'There was an error, please try again.'
export const CHECK_YOUR_INBOX = 'Check Your Inbox'

export const DESCRIPTION =
  'If this email address belongs to an account, you’ll receive an email containing a link to reset your password.'
